import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommonService } from '@src/app/services/common.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { copy } from '../../utils/common.util';

@Component({
    selector: 'app-copy',
    standalone: true,
    imports: [CommonModule, NzButtonModule, NzIconModule],
    templateUrl: './copy.component.html',
    styleUrls: ['./copy.component.less'],
})
export class CopyComponent {
    @Input() text = '';
    @Input() reminderMsg = 'Copied!';

    constructor(private commonService: CommonService) {}

    copy() {
        copy(this.text).then(() => this.commonService.success(this.reminderMsg));
    }
}
